import React from 'react';
import { translate } from '../../../lib/translations';

interface TradeStatusProps {
  isAccepted: boolean;
  language: 'en' | 'fr';
}

export function TradeStatus({ isAccepted, language }: TradeStatusProps) {
  return (
    <div className="mt-3">
      <span className={`badge ${isAccepted ? 'bg-success' : 'bg-danger'}`}>
        {isAccepted ? translate('trade.accepted', language) : translate('trade.rejected', language)}
      </span>
    </div>
  );
}